var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDaytona(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 211 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      flex: "none",
      lineHeight: 1
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Daytona") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.1428,
    y: 149.025,
    width: 76.2474,
    height: 26.1421,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 113.522,
    y: 57.5287,
    width: 87.1399,
    height: 26.1421,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 91.4971,
    height: 26.142,
    transform: "matrix(0.707105 -0.707108 0.707105 0.707108 67.7737 65.5858)",
    fill: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 70.2691,
    height: 26.142,
    transform: "matrix(-0.707105 -0.707108 -0.707105 0.707108 68.1729 130.941)",
    fill: "currentColor"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 74.0691,
    height: 26.142,
    transform: "matrix(-0.707105 0.707108 -0.707105 -0.707108 133.532 167.511)",
    fill: "currentColor"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 82.7831,
    height: 26.142,
    transform: "matrix(0.707105 0.707108 0.707105 -0.707108 133.133 102.156)",
    fill: "currentColor"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 67.7737,
    y: 37.9227,
    width: 63.1767,
    height: 26.142,
    transform: "rotate(90 67.7737 37.9227)",
    fill: "currentColor"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 159.278,
    y: 129.419,
    width: 78.4262,
    height: 26.142,
    transform: "rotate(90 159.278 129.419)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaytona);
export default __webpack_public_path__ + "static/media/daytona.7a6977d0bddee3113d82448ebcc1d352.svg";
export { ForwardRef as ReactComponent };